import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Avatar, InnerLayout, Pagination } from "../../components"

/* Helpers */
import { withRouter, utils } from "../../helpers"

/* REST API */
import { list } from "../../api/Bonus"

/* Moment */
import moment from "moment"

/* Modal */
import Modal from "react-modal"

/* Widgets */
import { JackpotModal } from "../../widgets/Bonus"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Translate */
import { t } from "../../translates/translate"

/* DatePicker Settings */
registerLocale("ru", ru)


/* Page Bonus */
class Bonus extends Component {

    constructor() {
        super()

        const date = utils.getDate()

        this.state = {
            data: [],
            status: "loading",
            count: 0,
            page: 1,
            operators: [],
            tables: [],

            search: "",

            filter: false,
            operatorID: 0,
            tableID: 0,
            start: date.startDate,
            end: date.endDate,

            visible: false,
            active: null,

            jackpotVisible: false,
        }

        this._timer = null
    }

    /* Load On Mount */
    componentDidMount = () => {
        this.load()
    }

    /* Create Search Timing */
    componentWillUnmount = () => {
        if (this._timer) {
            clearTimeout(this._timer)
            this._timer = null
        }
    }

    /* Load action */
    load = (reload = false, page = 1) => {

        /* Set Page */
        this.setState({ page })

        /* Reload Page */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Fields */
        const { search, operatorID, tableID, start, end } = this.state

        /* Send to REST API */
        list({ page, search, operatorID, tableID, start, end }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count, operators: response.data.operators, tables: response.data.tables })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })
    }


    /* Draw Container */
    _container = () => {

        const { status, data, page, count } = this.state

        if (status !== "ok") {
            return <InnerLayout status={status} inner reload={() => this.load(true, 1)} />
        }

        if (data.length === 0) {
            return (
                <div className="bonus--content-layout-empty">
                    {t("bonus.notFound")}
                </div>
            )
        }

        return (
            <div className="bonus--content">

                <div className="bonus-content-head">
                    <div className="bonus-content-head-number">#</div>
                    <div className="bonus-content-head-text operator">{t("bonus.operator")}</div>
                    <div className="bonus-content-head-text">{t("bonus.game")}</div>
                    <div className="bonus-content-head-text">{t("bonus.player")}</div>
                    <div className="bonus-content-head-text">{t("bonus.bet")}</div>
                    <div className="bonus-content-head-text">{t("bonus.win")}</div>
                    <div className="bonus-content-head-text date">{t("bonus.date")}</div>
                    <div className="bonus-content-head-more"></div>
                </div>

                {data.map((item, index) =>
                    <div onClick={() => this.setState({ visible: true, active: item })} className="bonus-content-row" key={`${index}`}>
                        <div className="bonus-content-number">{(page - 1) * 10 + index + 1}</div>
                        <div className="bonus-content-text operator">{item.operator}</div>
                        <div className="bonus-content-text table">
                            {item.game}
                            <span>{item.table}</span>
                        </div>
                        <div className="bonus-content-text">
                            <div className="bonus-content-user">
                                <Avatar uri={`/images/player/${item.image}`} size={30} />
                                <div className="bonus-content-user-box">
                                    <div className="bonus-content-user-name">{item.firstName}</div>
                                    <div className="bonus-content-user-player">{item.player}</div>
                                </div>
                            </div>
                        </div>
                        <div className="bonus-content-text bonus">
                            {utils.convertor(item.dollarBonus, "$", 0)}
                            {String(item.currency).toLowerCase() !== "usd" && <span>{utils.convertor(item.bonus, item.symbol, item.isAfter)} * {parseInt(item.currencyRate) > 0 ? Number(item.currencyRate).toFixed(2) : Number(item.currencyRate).toFixed(6)}</span>}
                        </div>
                        <div className="bonus-content-text win">
                            {utils.checkValue(item.win, null) ? utils.convertor(item.win * parseFloat(item.currencyRate), "$", 0) : "-"}
                            <span className="blue">{utils.checkValue(item.win, null) && utils.convertor(item.win, item.symbol, item.isAfter)}</span>
                            <span>{utils.checkValue(item.combination, "")}</span>
                            <span>{utils.checkValue(item.multiplier, null) && `${item.multiplier} : 1`}</span>
                        </div>
                        <div className="bonus-content-text date">
                            {moment(item.createdAt).format("HH:mm")}
                            <span>{moment(item.createdAt).format("DD MMM YYYY")}</span>
                        </div>
                        <div className="bonus-content-more">
                            <div className="bonus-content-arrow">
                                <img src="/images/arrow.png" alt="Arrow" />
                            </div>
                        </div>
                    </div>
                )}

                {/* Pagination */}
                <Pagination size={10} page={page} total={count} onPageChange={(page) => this.load(true, page)} />

            </div >
        )
    }


    /* View */
    _view = () => {

        const { visible, active } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.setState({ visible: false, active: null })}
                className="bonus--modal"
                overlayClassName="bonus--overlay"
                closeTimeoutMS={200}
            >

                <div className="bonus--modal-header">
                    <h2>{t("bonus.info")}</h2>
                    <div onClick={() => this.setState({ visible: false, active: null })} className="bonus--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {active &&
                    <div className="bonus--modal-container">
                        <div className="bonus--modal-box">

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/shape.png" alt="Shape" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.number")}</div>
                                    <div className="bonus--modal-element-value small">{active.uid}</div>
                                </div>
                            </div>

                            <div className="bonus--modal-element">
                                <Avatar uri={`/images/player/${active.image}`} size={24} />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{active.firstName}</div>
                                    <div className="bonus--modal-element-value">{active.player}</div>
                                </div>
                            </div>


                        </div>

                        <div className="bonus--modal-box">

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/platform.png" alt="Platform" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.operator")}</div>
                                    <div className="bonus--modal-element-value">{active.operator}</div>
                                </div>
                            </div>

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/spades.png" alt="Spades" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.gameNumber")}{active.gameNumber}</div>
                                    <div className="bonus--modal-element-value">{active.game}</div>
                                    <span>{active.table}</span>
                                </div>
                            </div>

                        </div>


                        <div className="bonus--modal-box">

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/clock.png" alt="Clock" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.date")}</div>
                                    <div className="bonus--modal-element-value">{moment(active.createdAt).format("HH:mm, DD MMM YYYY")}</div>
                                </div>
                            </div>

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/currency.png" alt="Currency" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.exchangeRate")}</div>
                                    {(parseFloat(active.currencyRate) > 0 && String(active.currency).toLowerCase() !== "usd") ? <div className="bonus--modal-element-value">{Number(1 / parseFloat(active.currencyRate)).toFixed(2)} ({active.currency} - USD)</div> : "-"}
                                </div>
                            </div>
                        </div>

                        <div className="bonus--modal-box">

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/poker-chip.png" alt="Poker Chip" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.bet")}</div>
                                    <div className="bonus--modal-element-value">{utils.convertor(active.dollarBonus, "$", 0)}</div>
                                    {String(active.currency).toLowerCase() !== "usd" && <span>{utils.convertor(active.bonus, active.symbol, active.isAfter)}</span>}
                                </div>
                            </div>

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/dollar-coin.png" alt="Dollar" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.win")}</div>
                                    <div className="bonus--modal-element-value">{utils.checkValue(active.win, null) ? utils.convertor(active.win * parseFloat(active.currencyRate), "$", 0) : "-"}</div>
                                    {String(active.currency).toLowerCase() !== "usd" && <span>{utils.checkValue(active.win, null) && utils.convertor(active.win, active.symbol, active.isAfter)}</span>}
                                </div>
                            </div>
                        </div>

                        <div className="bonus--modal-box">

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/poker-game.png" alt="Poker" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.combination")}</div>
                                    <div className="bonus--modal-element-value">{utils.checkValue(active.win, null) ? active.combination : "-"}</div>
                                </div>
                            </div>

                            <div className="bonus--modal-element">
                                <img src="/images/bonus/cross-mark.png" alt="Cross" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.multiplier")}</div>
                                    <div className="bonus--modal-element-value">{utils.checkValue(active.win, null) ? `${active.multiplier}:1` : "-"}</div>
                                </div>
                            </div>

                        </div>

                        <div className="bonus--modal-box">

                            <div className="bonus--modal-element big">
                                <img src="/images/bonus/jackpot.png" alt="Jackpot" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">JACKPOT ({parseFloat(active.jackpotRatio)})</div>
                                    <div className="bonus--modal-element-value">{utils.checkValue(active.jackpot, null) ? utils.convertor(active.jackpot, "$") : "-"}</div>
                                    <div className="bonus--modal-element-value green">+ {utils.convertor(parseFloat(active.dollarBonus) * parseFloat(active.jackpotRatio), "$", 0)}</div>
                                    <div className="bonus--modal-element-value">{utils.checkValue(active.jackpot, null) ? utils.convertor(parseFloat(active.jackpot) + parseFloat(active.dollarBonus) * parseFloat(active.jackpotRatio), "$") : "-"}</div>
                                </div>
                            </div>

                            <div className="bonus--modal-element big">
                                <img src="/images/bonus/safe-box.png" alt="Safe-box" />
                                <div className="bonus--modal-element-inner">
                                    <div className="bonus--modal-element-name">{t("bonus.cash")} ({1 - parseFloat(active.jackpotRatio)})</div>
                                    <div className="bonus--modal-element-value">{utils.checkValue(active.score, null) ? utils.convertor(active.score, "$") : "-"}</div>
                                    <div className="bonus--modal-element-value green">+ {utils.convertor(parseFloat(active.dollarBonus) * (1 - parseFloat(active.jackpotRatio)), "$", 0)}</div>
                                    {active.win ? <div className="bonus--modal-element-value red">- {utils.convertor(active.win * parseFloat(active.currencyRate), "$", 0)}</div> : null}
                                    <div className="bonus--modal-element-value">
                                        {utils.checkValue(active.score, null)
                                            ? utils.convertor(
                                                parseFloat(active.score)
                                                + parseFloat(active.dollarBonus) * (1 - parseFloat(active.jackpotRatio))
                                                - (active.win ? parseFloat(active.win) * parseFloat(active.currencyRate) : 0)
                                                , "$")
                                            : "-"}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                }

            </Modal>
        )
    }


    /* Clear Action */
    clear = () => {
        const date = utils.getDate()
        this.setState({ operatorID: 0, tableID: 0, start: date.startDate, end: date.endDate, filter: false }, () => this.load(true, 1))
    }

    /* Search Action */
    search = (text) => {

        this.setState({ search: text, status: "loading" })

        if (this._timer) {
            clearTimeout(this._timer)
            this._timer = null
        }

        this._timer = setTimeout(() => {
            this.load(true, 1)
        }, 800)
    }


    /* Draw Filter */
    _filter = () => {

        const { filter, operators, operatorID, tables, tableID, start, end } = this.state

        return (
            <Modal
                isOpen={filter}
                onRequestClose={() => this.setState({ filter: false })}
                className="bonus--modal"
                overlayClassName="bonus--overlay"
                closeTimeoutMS={200}
            >

                <div className="bonus--modal-header">
                    <h2>{t("bonus.filter")}</h2>
                    <div onClick={() => this.setState({ filter: false })} className="bonus--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="bonus--modal-filter-container">

                    <div className="bonus--modal-filter-label">{t("bonus.operators")}</div>
                    <div className="bonus-jackpot--filter-boxes">
                        {operators.map((item, index) =>
                            <div onClick={() => this.setState({ operatorID: item.id })} className={`bonus-jackpot--filter-box ${operatorID === item.id ? "bonus-jackpot--filter-box-selected" : ""}`} key={`${index}`}>{item.name}</div>
                        )}
                    </div>

                    <div className="bonus--modal-filter-label">{t("bonus.games")}</div>
                    <div className="bonus-jackpot--filter-boxes">
                        {tables.map((item, index) =>
                            <div onClick={() => this.setState({ tableID: item.id })} className={`bonus-jackpot--filter-box ${tableID === item.id ? "bonus-jackpot--filter-box-selected" : ""}`} key={`${index}`}>{item.name}</div>
                        )}
                    </div>

                    <div className="bonus--modal-filter-label">{t("bonus.date")}</div>
                    <div className="bonus-jackpot--filter-dates">

                        <DatePicker
                            selected={start}
                            onChange={(date) => this.setState({ start: date })}
                            selectsStart
                            startDate={start}
                            endDate={end}
                            dateFormat="dd-MM-yyyy"
                            locale="ru"
                        />

                        <DatePicker
                            selected={end}
                            onChange={(date) => this.setState({ end: date })}
                            selectsEnd
                            startDate={start}
                            endDate={end}
                            minDate={start}
                            dateFormat="dd-MM-yyyy"
                            locale="ru"
                        />

                    </div>

                </div>

                <div className="bonus-jackpot--filter-buttons">
                    <div onClick={() => this.clear()} className="bonus-jackpot--filter-clear">{t("bonus.reset")}</div>
                    <div onClick={() => this.setState({ filter: false }, () => this.load(true, 1))} className="bonus-jackpot--filter-apply">{t("filter.apply")}</div>
                </div>

            </Modal>
        )
    }


    /* Draw count */
    _count = () => {

        const { operatorID, tableID } = this.state

        let count = 1

        if (tableID > 0) {
            count = count + 1
        }

        if (operatorID > 0) {
            count = count + 1
        }

        return <div className="bonus--page-filter-count">{count}</div>
    }

    render = () => {

        /* Socket */
        const { search, jackpotVisible } = this.state
        const { socket } = this.props

        return (
            <div className="bonus--page">

                {/* Draw Header */}
                <div className="bonus--page-header">

                    {/* Page Title */}
                    <h1>{t("bonus.title")}</h1>

                    {/* Page Filters */}
                    <div className="bonus--page-filters">

                        {/* Search */}
                        <div className="bonus--page-search">
                            <img src="/images/bonus/search.png" alt="Search" />
                            <input value={search} onChange={(event) => this.search(event.target.value)} placeholder={t("bonus.search")} />
                        </div>

                        <div className="bonus--page-filters-box">

                            {/* Filter */}
                            <div onClick={() => this.setState({ filter: true })} className="bonus--page-filter">
                                <img src="/images/bonus/filter.png" alt="Filter" />
                                {this._count()}
                            </div>

                            {/* Excel */}
                            <div className="bonus--page-excel">
                                .XLSX
                            </div>

                            {/* Settings */}
                            <div className="bonus--page-settings" onClick={() => this.setState({ jackpotVisible: true })}>
                                <img src="/images/bonus/setting.png" alt="Settings" />
                                <div className="bonus--page-settings-text">
                                    <span>{t("bonus.settings")}</span>
                                    JACKPOT
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                {/* Container */}
                <div className="bonus--container">
                    {this._container()}
                </div>

                {/* Draw View Modal */}
                {this._view()}

                {/* Draw Filter Modal */}
                {this._filter()}

                {/* Draw Jackpot Modal */}
                <JackpotModal
                    socket={socket}
                    visible={jackpotVisible}
                    close={() => this.setState({ jackpotVisible: false })}
                />

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(withRouter(Bonus))
